export default __webpack_public_path__ + "static/media/8.8ee20109.jpg";